import React, { memo } from 'react';
import { Blok } from '../../interfaces/Blok.interface';
import { StoryblokAsset } from '../../interfaces/StoryblokAsset.interface';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import { storyblokEditable } from 'gatsby-source-storyblok';
import { LinkProps } from '../../interfaces/LinkProps.interface';
import Heading, { HeadingTypes } from '../Heading/Heading';
import SbImage from '../SbImage/SbImage';
import StoryblokLinkProvider from '../Utils/StoryblokLinkProvider/StoryblokLinkProvider';
import { PrimaryCTABlokProps } from '../PrimaryCTA/PrimaryCTA';
import ButtonLink from '../ButtonLink/ButtonLink';
import { ButtonType } from '../../interfaces/enums/ButtonType.enum';
import { ButtonSize } from '../../interfaces/enums/ButtonSize.enum';
import classNames from 'classnames';

interface Service {
  icon: StoryblokAsset;
  cta: LinkProps[];
}

interface ServiceCTAProps {
  services: Service[];
  heading: string;
}

export interface BlokProps extends Blok {
  blok: ServiceCTAProps;
}

const ServiceCTA: React.FC<BlokProps> = ({ blok }) => {
  const { heading, services } = blok;

  return (
    <section
      {...storyblokEditable(blok)}
      className="container mx-auto py-8 gap-x-6 gap-y-8 md:gap-y-10 grid grid-cols-12"
    >
      <div className="col-start-3 col-span-8">
        <div className="pb-3 sm:pb-1">
          {heading && (
            <Heading
              text={heading}
              headingType={HeadingTypes.h3}
              className={'text-center sm:text-left'}
            ></Heading>
          )}
        </div>
        <div className="grid grid-cols-12 gap-y-5 py-1 2xl:py-2 md:gap-x-6 xl:gap-x-16">
          {services.map(({ icon, cta }, idx) => (
            <div
              className={classNames(
                'col-span-12 md:col-span-6 lg:col-span-3 flex flex-col justify-center items-center space-y-1'
                // {
                //   'pr-8': idx == 0,
                //   'pl-8': idx == 3,
                //   'px-8': idx == 1 || idx == 2,
                // }
              )}
            >
              {icon && (
                <SbImage
                  asset={icon}
                  options={{
                    objectFit: 'contain',
                    width: 85,
                    height: 85,
                    sizes: { base: 112, md: 100, xl: 85 },
                    className: '!w-[60px] md:!w-[50px] xl:!w-[50px]',
                  }}
                />
              )}
              {cta.map(({ link, label, _uid }) => (
                <div className="w-full text-center" key={_uid}>
                  <StoryblokLinkProvider
                    link={link}
                    render={(link: string) => (
                      <ButtonLink
                        url={link}
                        label={label}
                        type={ButtonType.SECONDARY}
                        size={ButtonSize.MD}
                        className="max-w-[22em] sm:max-w-auto m-auto text-center w-full md:whitespace-nowrap !text-[13px] py-3"
                      >
                        {label}
                      </ButtonLink>
                    )}
                  />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default memo(withBlokWrapper(ServiceCTA));
